import React from "react"
import "./breadcrumb.scss"
import useBrowserMode from '../../../shared/hooks/useBrowserMode'

const Breadcrumb = (props: BreadcrumbInterface) => {
   const { content, useCustomBreadcrumbs, customBreadcrumbs } = props;
   const { isBrowser, window } = useBrowserMode();


   const getPathName = (index: number): string => {
      const paths = window.location.pathname.split('/');
      if (isBrowser) {
         if (content.includes('Biblioteca / Resultados de búsqueda')) {
            return '/servicio-de-empleo/' + paths[2] + '/' + paths[3];
         }
         if (content.includes('migrante')) {
            return '/servicio-de-empleo/personas/';
         } else if (index === 1 && content.includes('Centro de empleo')) {
            return '/servicio-de-empleo' + getFinalRoot(index, paths);
         }
         if (index === 0 && content.includes('/servicio-de-empleo')) {
            return '/servicio-de-empleo';
         } else if (index === 1 && content.includes('Encontrar Talento')) {
            return '/servicio-de-empleo/' + paths[2];
         }
         if (content.includes('/ Encontrar Talento /')) {
            return '/servicio-de-empleo/' + paths[2] + '/' + paths[3];
         } 
         if (content.includes('/ Mentoría de Talento')) {
            return '/servicio-de-empleo/personas/mentoria_talento/';
         }
         if (content.includes('personas') && index === 0) {
            return '/servicio-de-empleo/personas/';
         }
         if (content.includes('proyectos-inclusion-laboral') && index === 1) {
            return '/servicio-de-empleo/personas/proyectos-inclusion-laboral';
         }
         if (content.includes('empleo-mayores-de-50') && index === 2) {
            return '/servicio-de-empleo/personas/proyectos-inclusion-laboral/empleo-mayores-de-50/';
         }
         if (content.includes('empresas/solicitud-servicios')) {
            return '../';
         }
         if (content?.includes(""))
            return paths[index] ? getFinalRoot(index, paths) : '#';
      }
      return '';
   };

   const getFinalRoot = (n:number, paths:string[]) => {
      let pathFinal = '/';
      for (let i = 0; i < n; i++) {
         pathFinal += paths[i+1]+'/';
      }
      return pathFinal;
   }

   const breadcrumbs = (crumbs:string) => (
      crumbs.split('/').map( (value, index) => {
         return (
            <li key={index} itemProp="url" className={`crumb url-${index}${props.specialEvent ? ' --special-event' : ''}`}>
               <a title={value}
                  href={getPathName(index)}
                  rel="nofollow noreferrer"
               >
                  <span itemProp="title"> {value} </span>
               </a>
            </li>
         )}
      )
   );

   const RenderCustomBreadcrumbs = () => {
       return customBreadcrumbs?.map((breadcrumb, index) => {
         const isLast = index === customBreadcrumbs.length - 1;
         const href = isLast ? '#' : breadcrumb.url || '#';
           return (
               <li
                   key={`crumb-${breadcrumb.title}-${index}`}
                   itemProp="url"
                   className={`crumb url-${index}${
                       props.specialEvent ? " --special-event" : ""
                   }`}
               >
                   <a
                       title={breadcrumb.title}
                       href={href}
                       rel="nofollow noreferrer"
                   >
                       <span itemProp="title"> {breadcrumb.title} </span>
                   </a>
               </li>
           );
       });
   };

	return (
      <nav itemType="https://schema.org/Breadcrumb" className='miga-de-pan'>
         <ul className={`a-breadcrumb${props.specialEvent ? ' a-breadcrumb--special-event' : ''}`}>
            {isBrowser && !useCustomBreadcrumbs && breadcrumbs( content )}
            {isBrowser && useCustomBreadcrumbs && RenderCustomBreadcrumbs()}
         </ul>
      </nav>
	)
}

export type CustomBreadcrumb = {
   title: string;
   url?: string;
}

interface BreadcrumbInterface {
   content: any;
   specialEvent?: boolean;
   useCustomBreadcrumbs?: boolean
   customBreadcrumbs?: CustomBreadcrumb[] 
}

export default Breadcrumb
